import { BoxNotification } from 'components/containers/BoxNotification';
import { AutoImportStatus } from 'models/graphql';
import * as React from 'react';
import { Modal } from '../../../../components/containers/Modal';
import { ButtonColorsEnum } from '../../../../constants/button-colors';
import { AutoImportQueryResult } from '../AutoImporters.view';
import classes from './PauseImporterModal.module.scss';

export type PauseImporterModalViewProps = {
  onClose: () => void;
  onConfirmation: () => void;
  importer?: AutoImportQueryResult;
  loading: boolean;
  isImportersPaused: boolean;
};

export const PauseImporterModalView = ({
  onClose,
  onConfirmation,
  importer,
  loading,
  isImportersPaused
}: PauseImporterModalViewProps): JSX.Element => {
  const importerTitle = importer?.name;
  const isPaused = importer?.status === AutoImportStatus.PAUSED;

  // When no importer is passed, we process as bulk
  if (isImportersPaused && !importer) {
    return (
      <Modal
        title={'Un-Pause all Importing'}
        onClose={onClose}
        showCloseIcon={true}
        primaryButtonLoading={loading}
        primaryButtonColor={ButtonColorsEnum.secondary}
        primaryButtonTitle={'Un-Pause all Importing'}
        primaryButtonAction={onConfirmation}>
        <>
          <p>Un-Pausing all Auto-Importer will return importing all Posts.</p>
          <BoxNotification type={'info'}>
            You can pause some or all of them at any point to continue importing
          </BoxNotification>
        </>
      </Modal>
    );
  }

  if (!isPaused) {
    return (
      <Modal
        title={importerTitle ? 'Pause Auto-Importer' : 'Pause all Importing'}
        onClose={onClose}
        showCloseIcon={true}
        primaryButtonLoading={loading}
        primaryButtonColor={ButtonColorsEnum.secondary}
        primaryButtonTitle={importerTitle ? 'Pause Auto-Importer' : 'Pause all Importing'}
        primaryButtonAction={onConfirmation}>
        {importerTitle ? (
          <p>
            Pausing Auto-Importer <span className={classes.NameImport}>{`${importerTitle}`}</span> will temporarily stop
            importing Posts.
          </p>
        ) : (
          <>
            <p>
              When &quot;All Auto-Importing is Paused&quot;, no new posts will be fetched from any of your
              Auto-Importers, regardless of whether they are active or paused.
            </p>
            <p>Alternatively, you can pause individual Auto-Importers.</p>
          </>
        )}

        {importerTitle && (
          <BoxNotification type={'info'}>You can unpause it at any point to continue importing</BoxNotification>
        )}
      </Modal>
    );
  }

  // We fall through to process a single item
  return (
    <Modal
      title={importerTitle ? 'Un-Pause Auto-Importer' : 'Un-Pause all Importing'}
      onClose={onClose}
      showCloseIcon={true}
      primaryButtonLoading={loading}
      primaryButtonColor={ButtonColorsEnum.secondary}
      primaryButtonTitle={importerTitle ? 'Un-Pause Auto-Importer' : 'Un-Pause all Importing'}
      primaryButtonAction={onConfirmation}>
      {importerTitle ? (
        <p>
          Un-pausing Auto-Importer <span className={classes.NameImport}>{`${importerTitle}`}</span> will return to
          importing Posts.
        </p>
      ) : (
        <p>Un-Pausing all your Auto-Importers will return importing Posts from all of them.</p>
      )}

      <BoxNotification type={'info'}>
        {importerTitle
          ? 'You can pause it at any point to stop importing'
          : 'You can pause some or all of them at any point to stop importing'}
      </BoxNotification>
    </Modal>
  );
};
